import { useAppSelector } from 'store/store'
import { UserDetailsDialog } from 'ui/components/users/UserDetailsDialog'
import { useUsers } from '../context/users-context'
import { UsersDeleteDialog } from './users-delete-dialog'

export function UsersDialogs() {
  const { open, setOpen, currentRow, setCurrentRow } = useUsers()
  // The row as it is now in the users page store, so premium and ban changes
  // made from the table show up in the open dialog too. Other pages (membership
  // codes) open it with a plain BackofficeUser.
  const liveRow = useAppSelector((state) =>
    state.users.users?.find(({ id }) => id === currentRow?.id)
  )
  const user = liveRow ?? currentRow
  return (
    <>
      {user && (
        <>
          <UserDetailsDialog
            key={`user-edit-${user.id}`}
            open={open === 'edit'}
            onOpenChange={() => {
              setOpen('edit')
              setTimeout(() => {
                setCurrentRow(null)
              }, 500)
            }}
            user={user}
          />

          <UsersDeleteDialog
            key={`user-delete-${user.id}`}
            open={open === 'delete'}
            onOpenChange={() => {
              setOpen('delete')
              setTimeout(() => {
                setCurrentRow(null)
              }, 500)
            }}
            currentRow={user}
          />
        </>
      )}
    </>
  )
}
